import { render } from "./PageIconCard.vue?vue&type=template&id=52bc902f&ts=true"
import script from "./PageIconCard.vue?vue&type=script&lang=ts"
export * from "./PageIconCard.vue?vue&type=script&lang=ts"

import "./PageIconCard.vue?vue&type=style&index=0&id=52bc902f&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__